/* eslint-disable multiline-ternary */
import React, { type ReactElement, useEffect, useState } from "react"
import { Button } from "@chakra-ui/react"
import { AddIcon, CheckIcon, MinusIcon } from "@chakra-ui/icons"

interface SelectButtonInterface {
  defaultState: boolean
  onClickCallBack: (value: boolean, systemId: number) => void
  addToFMP: Set<unknown>
  removeFromFMP: Set<unknown>
  systemId: number
  isBlank?: boolean
}

// export const SelectButton = ({ defaultState, onClickCallBack, noToggle = false, isBlank }: SelectButtonInterface): ReactElement => {
export const SelectButton = ({ onClickCallBack, systemId, addToFMP, removeFromFMP, isBlank, defaultState }: SelectButtonInterface): ReactElement => {
  // Tracks whether the user has toggled this row away from its saved
  // defaultState - NOT the row's checked/unchecked appearance itself (that's
  // driven by defaultState/presentInAddToFMP/presentInRemoveFromFMP below).
  // Must start at false regardless of defaultState: initialising it from
  // defaultState made the very first click on an already-allocated (green
  // tick, defaultState=true) row compute `!true = false`, which the parent's
  // handleSelect reads as "no pending change" and ignores - so the first
  // click on those rows silently did nothing and only the second click
  // (toggling true) actually registered.
  const [isToggled, setIsToggled] = useState(false)
  useEffect(() => {
    setIsToggled(false)
  }, [defaultState])
  const addToFMPArray = Array.from(addToFMP)
  const removeFromFMPArray = Array.from(removeFromFMP)

  const presentInAddToFMP = addToFMPArray.includes(systemId)
  const presentInRemoveFromFMP = removeFromFMPArray.includes(systemId)
  // const getIcon = ({ toggle, defaultState, selected }: GetIconProps): IconType => {
  //   if (defaultState && !selected) {
  //     return IconType.Check
  //   }
  //   if (!toggle && !selected) {
  //     return IconType.Add
  //   }
  //   if (defaultState && selected) {
  //     return IconType.Minus
  //   }

  //   return IconType.Check
  // }

  // const getBgcolor = useCallback(
  //   (selected: boolean, noToggle: boolean): string => {
  //     if (selected && !noToggle) {
  //       return 'green'
  //     }
  //     return 'primary'
  //   },
  //   [defaultState]
  // )

  return (
    <>
      {isBlank ? (
        <Button variant="Button1Small" borderRadius={0} h="100%" w="100%" minW={"auto"} px="1" bg="primary">
          &nbsp;
        </Button>
      ) : (
        <Button
          onClick={() => {
            const currentValue = !isToggled
            setIsToggled(currentValue)
            onClickCallBack(currentValue, systemId)
          }}
          variant="Button1Small"
          borderRadius={0}
          h="100%"
          w="100%"
          minW={"auto"}
          px="1"
          bg={
            presentInAddToFMP || presentInRemoveFromFMP
              ? "#D97706"
              : defaultState
                ? "green"
                : "gray.50"
          }
          _hover={
            presentInAddToFMP || presentInRemoveFromFMP
              ? { bg: "#B45309" }
              : defaultState
                ? { bg: "#006400" }
                : { bg: "gray.100" }
          }
        >
          {presentInAddToFMP && <CheckIcon />}
          {presentInRemoveFromFMP && <MinusIcon />}
          {!presentInAddToFMP && !presentInRemoveFromFMP && defaultState && <CheckIcon />}
          {!presentInAddToFMP && !presentInRemoveFromFMP && !defaultState && <AddIcon />}
          {/* {getIcon({ toggle: noToggle, defaultState, selected }) === IconType.Add ? <AddIcon /> : null}
          {getIcon({ toggle: noToggle, defaultState, selected }) === IconType.Check ? <CheckIcon /> : null}
          {getIcon({ toggle: noToggle, defaultState, selected }) === IconType.Minus ? <MinusIcon /> : null} */}
          {/* <GetIcon toggle={noToggle} defaultState={defaultState} selected={selected} /> */}
        </Button>
      )}
    </>
  )
}
